<template>
	<el-form v-loading="loading" ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="110px"
		class="demo-ruleForm scroll_y" size="large" status-icon>
		<el-form-item label="专业名称" prop="name">
			<el-input v-model="ruleForm.name" placeholder="请填写专业名称" class="middle_input" />
		</el-form-item>
		<el-row>
			<el-col :span="12">
				<el-form-item label="所属专业类别" prop="majorCategoryId">
					<el-select v-model="ruleForm.majorCategoryId" class="m-2 small_input" placeholder="请选择专业类别">
						<el-option v-for="item in categorySel" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="报考形式" prop="examinationStyle">
					<!-- <el-select v-model="ruleForm.examinationStyle" class="m-2 small_input" placeholder="请选择报考形式">
						<el-option v-for="item in $constGlobal.testModality" :key="item.key" :label="item.value"
							:value="item.value" />
					</el-select> -->
					<el-input v-model="ruleForm.examinationStyle" placeholder="请填写报考形式" class="small_input" />
				</el-form-item>
			</el-col>
		</el-row>
		<el-form-item label="院校类别" prop="categoryId">
			<el-select v-model="ruleForm.categoryId" class="m-2 small_input" placeholder="请选择院校类别" @change="schoolCategoryChages">
				<el-option v-for="item in $constGlobal.SchoolCategoryList" :key="item.key" :label="item.value" :value="item.key" />
			</el-select>
		</el-form-item>
		<el-form-item label="关键字" prop="keywords">
			<el-col :span="24">
				<el-tag v-for="(item, index) in ruleForm.keywords" :key="item" closable
					@close="delTag(index, ruleForm.keywords)">
					{{ item }}
				</el-tag>
			</el-col>
			<el-col v-if="ruleForm.keywords.length !== 6">
				<el-input class="small_input" v-model="keyword" placeholder="单个标签长度8个字以内" maxlength="8" clearable>
				</el-input>
				<el-button v-if="ruleForm.keywords.length !== 6" type="primary" @click="addTag(keyword, ruleForm.keywords)"
					plain>
					<el-icon>
						<Plus />
					</el-icon>&nbsp;添加
				</el-button>
			</el-col>
		</el-form-item>
		<!-- prop="majorCode" -->
		<el-form-item label="专业代码" v-if="isGuoKai">
			<el-input class="small_input" type="number" v-model="ruleForm.majorCode" placeholder="请填写专业代码"
				@mousewheel.prevent @keyup="prevent($event)" />
		</el-form-item>
		<el-form-item label="专业代码" prop="majorCode" v-else>
			<el-input class="small_input" type="number" v-model="ruleForm.majorCode" placeholder="请填写专业代码"
				@mousewheel.prevent @keyup="prevent($event)" />
		</el-form-item>
		<el-form-item label="学习形式" prop="studyForm">
			<el-select v-model="ruleForm.studyForm" class="m-2 small_input" placeholder="请选择学习形式">
				<el-option v-for="item in studyFormList " :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
		</el-form-item>
		<el-form-item label="学制" prop="studySystem">
			<el-input class="small_input" v-model="ruleForm.studySystem" type="number" placeholder="请填写学制">
			</el-input><span class="mag_left">年</span>
		</el-form-item>
		<el-form-item label="考试科目" prop="examCourse">
			<el-input v-model="ruleForm.examCourse" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea"
				placeholder="请填写考试科目" />
		</el-form-item>

		<el-form-item label="就业方向" prop="jobOrientation">
			<el-input v-model="ruleForm.jobOrientation" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea"
				placeholder="请填写就业方向" />
		</el-form-item>
		<el-form-item label="主修课程" prop="majorCourses">
			<WangEditor v-if="editorShow" :isDeCode="false" ref="majorCourses" :content="ruleForm.majorCourses"
				@changeContent="setmajorCourses" />
		</el-form-item>
		<el-form-item label="专业描述" prop="summary">
			<WangEditor v-if="editorShow" ref="summary" :isDecode="false" :content="ruleForm.summary" @changeContent="setsummary" />
		</el-form-item>
	</el-form>
	<div slot="footer" class="from_btn">
		<el-button @click="resetForm" size="large">取消</el-button>
		<el-button v-if="!submitDisabled" type="primary" size="large" @click="submitForm(ruleFormRef)"  :disabled = "submitDisabled">提交</el-button>
		<el-button type="primary" size="large" loading v-else>提交中</el-button>
	</div>
</template>

<script>
import {
	getMajorDetail,
	addMajor,
	updateMajor
} from "network/notPbMajor.js";
import {
	toRefs,
	reactive,
	ref,
	unref,
	onMounted
} from "vue";
import {
	ElMessage,
	ElMessageBox
} from "element-plus";
import WangEditor from "components/wangEditor/WangEditor.vue";
import {
	textFilter,
	isEditorNull
} from "common/utils.js";
export default {
	name: "AddEditPbMajor",
	components: {
		WangEditor
	},
	emits: {
		"close-dialog": null,
		"update-list": null,
	},
	props: {
		editId: Number,
		categorySel: Array,
	},
	setup(props, {
		emit
	}) {
		const ruleFormRef = ref();
		const data = reactive({
			loading: false,
			editorShow: false, //用于获取到编辑详情 回显富文本
			isGuoKai:false,
			ruleForm: {
				id: 0,
				majorCategoryId: null,
				categoryId:null,
				name: null,
				keywords: [],
				summary: "",
				majorCourses: "",
				jobOrientation: null,
				majorCode: null,
				examinationStyle: null,
				examCourse: null,
				studySystem: null,
				studyForm: null
			},
			rules: {
				name: [{
					required: true,
					message: "请填写专业名称"
				},
				{
					min: 2,
					max: 15,
					message: "专业名称为2-15字"
				},
				],
				majorCategoryId: [{
					required: true,
					message: "请选择所属专业类别",
					trigger: "change",
				},],
				categoryId:[{
					required: true,
					message: "请选择院校类别",
					trigger: "change",
				}],
				keywords: [{
					required: true,
					message: "请选择设置关键字",
					trigger: "change",
				},],
				majorCode: [{
					required: true,
					message: "请填写专业代码",
					trigger: "blur",
				},],
				examinationStyle: [{
					required: true,
					message: "请填写报考形式",
					trigger: "blur",
				},],
				summary: [{
					required: true,
					message: "请填写专业描述",
					trigger: "blur",
				},
				{
					validator: (rule, value, callback) => {
						let isEmpty = isEditorNull(textFilter(value));
						if (isEmpty) {
							callback(new Error("请填写专业描述"));
						} else {
							callback();
						}
					},
				},
				],
			},
			keyword: "", //关键字
			schoolClass: [],
			studyFormList: [{
				label: '业余形式',
				value: 1
			}, {
				label: '函授形式',
				value: 2
			}],
			submitDisabled:false
		});
		onMounted(() => {
			//编辑-获取详情
			if (props.editId > 0) {
				data.loading = true;
				getMajorDetail(props.editId).then((result) => {
					if (result && result.code == 1) {
						data.loading = false;
						data.editorShow = true;
						data.ruleForm = result.result;
						data.ruleForm.keywords = result.result.keywordList;
						if(result.result.categoryId == 51){
							data.isGuoKai = true
						}else{
							data.isGuoKai = false
						}
					} else {
						data.loading = false;
						ElMessage.error(result.message);
					}
				});
			} else {
				//添加
				data.editorShow = true;
			}
		});

		//添加关键字
		const addTag = (val, valAll) => {
			if (val == "" || val == null || val.length < 2) {
				ElMessage.error("请输入2-8个字");
				return false;
			}
			if (valAll.length >= 6) {
				data.keyword = "";
				ElMessage.error("最多只能设置6个");
				return false;
			}
			var index = valAll.indexOf(val);
			if (index >= 0) {
				ElMessage.error("关键字[" + val + "]已存在");
				return false;
			}
			valAll.push(val);
			data.ruleForm.keywords = valAll;
			ElMessage({
				message: "添加成功！",
				type: "success"
			});
			data.keyword = "";
		};
		//删除关键字
		const delTag = (index, valAll) => {
			valAll.splice(index, 1);
			ElMessage({
				message: "删除成功！",
				type: "success"
			});
		};
		//获取富文本编辑器传过来的 主修课程
		const setmajorCourses = (val) => {
			if (val) {
				data.ruleForm.majorCourses = val;
				ruleFormRef.value.clearValidate("majorCourses"); //移除校验结果
			}
		};
		//获取富文本编辑器传过来的 专业描述
		const setsummary = (val) => {
			if (val) {
				data.ruleForm.summary = val;
				// data.ruleForm.summary = encodeURIComponent(val);
				ruleFormRef.value.clearValidate("summary"); //移除校验结果
			}
		};
		// 提交
		const submitForm = async () => {
			const form = unref(ruleFormRef);
			// if (!data.ruleForm.summary) {
			//   ElMessage.warning("请填写专业描述");
			// }
			if (!form) return;
			try {
				const valid = await form.validate();
				if (!valid) {
					return false;
				} else {
					data.submitDisabled = true;
					updataAdd(data.ruleForm).then(()=>{
			          data.submitDisabled = false;
					});
				}
			} catch (error) {
				ElMessage.error("有必填内容未填写！");
				console.log(error);
			}
		};
		async function updataAdd(data) {
			data.loading = true;
			let result = "";
			if (props.editId > 0) {
				result = await updateMajor(data);
			} else {
				result = await addMajor(data);
			}
			if (result && result.code == 1) {
				data.loading = false;
				ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
					confirmButtonText: "确定",
				});
				emit("close-dialog");
				emit("update-list");
			}else{
				data.loading = false;
				ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
					confirmButtonText: "确定",
				});
			}
		}

		// 取消操作  关闭弹窗
		const resetForm = () => {
			emit("close-dialog");
			ruleFormRef.value.resetFields();
		};
		//禁止输入小数以及负数
		const prevent = (e) => {
			var keynum = window.event ? e.keyCode : e.which; //获取键盘码
			if (keynum == 189 || keynum == 190 || keynum == 109 || keynum == 110) {
				ElMessage.warning("禁止输入小数以及负数");
				e.target.value = "";
			}
		};
		const schoolCategoryChages = (e) =>{
			if(e == 51){
				data.isGuoKai = true
			}else{
				data.isGuoKai = false
			}
		};
		return {
			...toRefs(data),
			addTag,
			delTag,
			setmajorCourses,
			setsummary,
			submitForm,
			ruleFormRef,
			resetForm,
			prevent,
			schoolCategoryChages
		};
	},
};
</script>
<style scoped>
:deep(.el-input__inner) {
	outline: none;
	line-height: 1px;
}

.demo-ruleForm {
	width: 100%;
	height: 500px;
}

.mag_left {
	margin-left: 10px;
}
</style>
